import * as React from "react";

const NoMatch = () => {
   return (
      <div>
         <p>404 ERROR</p>
      </div>
   );
};

export default NoMatch;
